export enum StatusEnum {
  PENDING = 'pending',
  SUCCESS = 'success',
  ERROR = 'error'
}
